"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconRelaisColis = void 0;
var React = __importStar(require("react"));
var IconRelaisColis = function (props) { return (React.createElement("svg", __assign({ width: "24px", height: "24px", viewBox: "0 0 24 24" }, props),
    React.createElement("title", null, 'Delivery/ic_relais_colis'),
    React.createElement("g", { fill: "none", fillRule: "evenodd" },
        React.createElement("rect", { width: 24, height: 24 }),
        React.createElement("text", { fill: "#E61E3F", fontFamily: "LucidaGrande-Bold, Lucida Grande", fontSize: 3, fontWeight: "bold" },
            React.createElement("tspan", { x: 3.5, y: 22 }, 'relais colis')),
        React.createElement("circle", { cx: 12, cy: 10, r: 8, fill: "#C2D64A" }),
        React.createElement("path", { fill: "#FFF", d: "M11.9151344,4 C12.4674191,4 12.9151344,4.44771525 12.9151344,5 L12.915,12.872 L16.1874579,10.1269865 C16.6105326,9.77198474 17.2412881,9.8271687 17.5962899,10.2502434 C17.9512917,10.673318 17.8961078,11.3040736 17.4730331,11.6590754 L12.8767664,15.5158011 C12.7869793,15.5911414 12.6878383,15.6480072 12.5839644,15.6868026 C12.4308692,15.8116992 12.2348999,15.8865285 12.0214532,15.8865285 L11.9681992,15.8849404 L11.9681992,15.8849404 L11.9151344,15.8801817 L11.9151344,15.8801817 C11.6650469,15.9101468 11.4267273,15.8337565 11.2454904,15.6866283 C11.1424305,15.6480072 11.0432895,15.5911414 10.9535023,15.5158011 L10.9535023,15.5158011 L6.35723567,11.6590754 C5.93416101,11.3040736 5.87897705,10.673318 6.23397884,10.2502434 C6.58898063,9.8271687 7.21973623,9.77198474 7.64281089,10.1269865 L7.64281089,10.1269865 L10.915,12.872 L10.9151344,5 C10.9151344,4.44771525 11.3628496,4 11.9151344,4 Z" })))); };
exports.IconRelaisColis = IconRelaisColis;
exports.IconRelaisColis.defaultProps = {
    height: '30px',
    width: '30px'
};
exports.default = exports.IconRelaisColis;
